<template>
	<v-container  fluid class="pt-3 mb-1">
		<div v-if="loggedInEmployee.isAdmin">
			<billing-current-plan
				v-if="subscription"
				:subscription="subscription"/>
			<div v-else>
				<product-plan-intro />
				<product-plan-selector @selectPlan="handlePlanSelected"/>
				<v-dialog v-model="isDialogOpen" max-width="900px" persistent>
					<product-plan-enrol
						:product-plan="selectedProductPlan"
						:pricing-option-id="selectedPricingOptionId"
						@onClose="isDialogOpen = false"
						@subscribed="handleSubscribed"/>
				</v-dialog>

			</div>
		</div>
		<div v-else>You do not have access</div>
	</v-container>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex';
	import LoadingIndicator from '@/components/common/LoadingIndicator';
    import BillingCurrentPlan from '@/components/settings/billing/BillingCurrentPlan'
    import ProductPlanSelector from '@/components/settings/billing/ProductPlanSelector'
	import ProductPlanEnrol from '@/components/settings/billing/ProductPlanEnrol'
	import ProductPlanIntro from '@components/settings/billing/ProductPlanIntro.vue';

	export default {
		components: { ProductPlanIntro, LoadingIndicator, BillingCurrentPlan, ProductPlanSelector, ProductPlanEnrol },
		data() {
			return {
				selectedProductPlan: null,
				selectedPricingOptionId: null,
				hasProductPlan: false,
				isDialogOpen: false,
			};
		},
		created() {
			this.$store.dispatch('setPageTitle', 'Billing');

			if (!this.hasLoadedProductPlans) {
				this.$store.dispatch('productPlans/get');
			}
		},
		computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee',
				hasLoadedProductPlans: 'productPlans/hasLoaded',
				subscription: 'loggedInSubscription'
			}),
		},
		watch: {
			isDialogOpen(val) {
				if (!val) this.selectedProductPlan = null;
			}
		},
		methods: {
			...mapActions({
				subscribeToPlan: 'productPlans/subscribe',
			}),
			handlePlanSelected(planAndPricingOptionId) {
				this.selectedProductPlan = planAndPricingOptionId.plan;
				this.selectedPricingOptionId = planAndPricingOptionId.pricingId
				this.isDialogOpen = true;
			},
			handleSubscribed() {
				this.isDialogOpen = false;
			},
		}
	};
</script>

<style scoped>
	
</style>